export default {
    baseUrl:'https://pic.imamhussain.org/index.php',
    apiUrl:'https://pic.imamhussain.org/index.php/api',
};